// extracted by mini-css-extract-plugin
export default {"container":"Zo-z","brandName":"_o-z","productName":"ap-z","productNamePdpEnhancements":"bp-z","breakLongProductName":"cp-z"};